import React, {useEffect, useState} from 'react';
import BottomMobileMenu from './BottomMobileMenu';
import Head from 'next/head';
import Navbar from './Navbar';
import Footer from './Footer';
import Router from 'next/router';
import Login from './Login';
import UpdatePassword from './auth/UpdatePassword';
import { useAuthContext } from '../hooks/useAuthContext';
import { useStateContext } from '../context/StateContext';
import { validateToken } from '../lib/authUtils';
import Loading from './Loading';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';
import AcceptPrivacyPolicy from './auth/AcceptPrivacyPolicy';
import { useOfflineContext } from '../context/OfflineContext';
import { logDoc } from './gestioneDatabase/Docs';
import { isToday } from 'date-fns';
import { useSetOnlyPassedData } from '../hooks/mutations';


const Layout = ({ children }) => {
  const { user} = useAuthContext();
  const { bypassNewPassword, apiUrl, loading, setLoading, sUser, setSUser  } = useStateContext();
  const { failedDevicesQueryDocs} = useOfflineContext()
  const [isValidToken, setIsValidToken] = useState(true);

        const {mutate: updateUser} = useSetOnlyPassedData({
            onSuccess: (data) => {
                console.log("User Updated Successfully", data);
                setSUser({...sUser, ...data})
                //const updatedSUserDoc = {...sUser, acceptedPrivacyPolicy: true}
                //setSUser(updatedSUserDoc)
                },
    
            onError: (err, newDoc, context) => {
                console.error('Oh no, the update failed: ', err?.message)
                errorAlert("ERRORE; Il documento non è stato modificato Ricarica la pagina")
                
                //queryClient.setQueryData(['customerProductsReport'], context?.previousData)
    
            }
            })


  useEffect(() => {
    const checkToken = async () => {
      if (user?.token) {
        try {
          setLoading(true);
          const isValid = await validateToken(`${apiUrl}/users/validate-token`, user.token);
          setIsValidToken(isValid);
          //console.log("sjkdladmkkldmaslkd", isValid)
          
          if (!isValid) {
            console.log("Token validation failed, removing token");
            if (typeof window !== 'undefined') {
              localStorage.removeItem('token');
              
              // Clear any localforage data that might be causing issues
              if (window.localforage) {
                try {
                  // Only clear specific authentication-related items
                  await window.localforage.removeItem('user');
                  console.log("Cleared user data from localforage");
                } catch (e) {
                  console.error("Error clearing localforage:", e);
                }
              }
            }
          }
          if(sUser?.userType == "Cliente" && isValid) 
            {
              const log = logDoc(sUser, "LoggedIn")
              const userLogs = !Array.isArray(sUser?.userLog) ? [] : sUser?.userLog?.sort(function(a, b){return b?.date - a?.date})
              const lastLog = userLogs?.length > 0 ? userLogs[0] : {}
              const isLastLogToday = isToday(lastLog?.date)
              if(!isLastLogToday) {
                const queryDoc = {
                    documentId: sUser?._id,
                    doc: {userLog:[...!Array.isArray(sUser?.userLog) ? [] : sUser?.userLog, log]}
                }
                console.log("Client logging dopkwodkwe", )
                updateUser(queryDoc)
              } else {
                console.log("Client already logged today qpwodkqwpodk")
              }
          }
        } catch (error) {
          console.error("Token validation error:", error);
          setIsValidToken(false);
          
          if (typeof window !== 'undefined') {
            localStorage.removeItem('token');
          }
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    
    // Only check token once when component mounts or token changes
    if(!Array.isArray(failedDevicesQueryDocs) || !failedDevicesQueryDocs || failedDevicesQueryDocs?.length < 1) {
      checkToken();
      //console.log("USER VALDATION o2iejoi23jd", {user, sUser}) 
    }

    
  }, [user?.token, apiUrl, failedDevicesQueryDocs, sUser]);

  if (!user) return <Login/>;
  
  if (!isValidToken) return <Login/>;
  
  if (!user?.passwordExists && !bypassNewPassword) return <UpdatePassword/>;

  if (sUser && !sUser?.acceptedPrivacyPolicy) return <AcceptPrivacyPolicy/>

  return (
    <div className="layout">
      <Head className="main-container">
        <title>GssMega</title>
      </Head>
      <header  className="main-container">
        <Navbar />
      </header>
      <main className="main-container">
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // Reset the state of your app here
            window.location.reload();
          }}
          onError={(error, errorInfo) => {
            // Log error details
            console.error('Error:', error);
            console.error('Error Info:', errorInfo);
          }}
        >
          {children}
        </ErrorBoundary>
      </main>
      <footer className="main-container">
        <Footer />
      </footer> 
    </div>
  )
}

export default Layout;
